import { HttpClient } from '../../httpClient'

export const createPptxExport = async ({
  id,
  type = 'presentation',
}: {
  id: number | string
  type?: 'presentation'
}): Promise<void> => {
  await HttpClient().post('/presentations/exports', {
    id,
    type,
    export_format: 'pptx',
  })
}
